var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPumpkin = function SvgPumpkin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.9 5.888c.247.018.607.047.856.086a8.745 8.745 0 0 1 7.461 9.347h0a8.836 8.836 0 0 1-8.888 7.929H9.673a8.836 8.836 0 0 1-8.888-7.929h0A8.75 8.75 0 0 1 8.4 5.951c.2-.027.507-.048.7-.063"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m17.25 17.25-1.513 1.4a.587.587 0 0 1-.8-.025l-.868-.932a.585.585 0 0 0-.823 0l-.836.9a.585.585 0 0 1-.824 0l-.836-.9a.585.585 0 0 0-.823 0l-.868.932a.587.587 0 0 1-.8.025l-1.509-1.4M4.5 13.534a2.154 2.154 0 0 1 2.25-2.045A2.154 2.154 0 0 1 9 13.534m10.5 0a2.154 2.154 0 0 0-2.25-2.045A2.155 2.155 0 0 0 15 13.534m-3-8.693V.75m4.614 7.5A5.1 5.1 0 0 0 12 4.841 5.1 5.1 0 0 0 7.386 8.25"
  })));
};
export default SvgPumpkin;